import {
  allLanguagesPaths,
  coreCountryLocales,
  helpPaths,
  helpCentreLocaleCodes,
  defaultEnvironment,
  defaultLocale,
  helpCentreRootUrls,
  privacyCenterRootUrls,
  helpCentreLoginRootUrls,
  helpCentreLoginPath,
  privacyPaths,
  HelpCentreLocaleKeys,
} from './helpLinks.constants';
import {
  getHelpLinkParams,
  HelpPathKeys,
  TranslatedHelpLinks,
  HelpCentreLocaleCodesType,
  GetAllHelplinksParams,
  getHelpLoginLinkParams,
} from './helpLinks.types';

export const normaliseLocale = (locale: string) => locale.replace('-', '_'); // support both en_GB and en-GB

export const isSupportedInHelpCentre = (
  locale: any,
): locale is HelpCentreLocaleCodesType => {
  return locale in helpCentreLocaleCodes;
};

export const translateHelpLink = ({
  helpLink,
  locale,
}: {
  helpLink: string;
  locale: string;
}) => {
  const defaultLinkLocale = helpCentreLocaleCodes[defaultLocale];

  if (isSupportedInHelpCentre(locale) && locale !== defaultLocale) {
    const localeCode = helpCentreLocaleCodes[locale];

    return helpLink.replace(defaultLinkLocale, localeCode);
  }

  return helpLink;
};

export const getHelplink = ({
  key,
  locale,
  environment = defaultEnvironment,
}: getHelpLinkParams) => {
  let helpCentreRootUrl = privacyPaths.includes(
    key as (typeof privacyPaths)[number],
  )
    ? privacyCenterRootUrls[environment]
    : helpCentreRootUrls[environment];
  const helpPath = helpPaths[key];

  let helpLink = `${helpCentreRootUrl}/${helpPath}`;
  const normalisedLocale = normaliseLocale(locale);

  const translateThisLocale =
    coreCountryLocales.includes(normalisedLocale as HelpCentreLocaleKeys) || // all articles should be available in core languages
    allLanguagesPaths.includes(key as HelpPathKeys); // but only some articles are available in all languages

  return translateThisLocale
    ? translateHelpLink({ helpLink, locale: normalisedLocale })
    : helpLink;
};

export const getAllHelplinks = ({
  locale,
  environment = defaultEnvironment,
}: GetAllHelplinksParams) => {
  const translatedHelpLinks = (Object.keys(helpPaths) as HelpPathKeys[]).reduce(
    (acc, key) => {
      acc[key] = getHelplink({
        key,
        locale,
        environment,
      });
      return acc;
    },
    {} as TranslatedHelpLinks,
  );

  return translatedHelpLinks;
};

export const getHelpLoginLink = ({
  environment = defaultEnvironment,
  zendeskToken,
}: getHelpLoginLinkParams) => {
  const helpCentreRootUrl = helpCentreLoginRootUrls[environment];

  return `${helpCentreRootUrl}/${helpCentreLoginPath}/jwt?jwt=${zendeskToken}`;
};
